import i18next from "i18next";
import React from "react";
import getEnv, { getGA } from "../../utils/getAppEnv";
import getBaseUrl from "../../utils/getBaseUrl";
import getImageBaseUrl from "../../utils/getImageBaseUrl";
import "./MountCategories.css";

interface Props {
  categoryDatas: [
    {
      familyName: string;
      familyImgURL: string;
      numOfFamilyMount: 0;
      mountList: [{}];
    }
  ];
  updateData: any;
  mountDetail?: any;
  failSafe?: any;
}
const getLink = (
  category: {
    familyName: any;
    familyImgURL?: string;
    numOfFamilyMount?: 0;
    mountList?: [{}];
  },
  mountDetail: any,
  failSafe: any
) => {
  let url = encodeURI(window.location.href);
  url = url.split("?")[0];
  if (!url.includes("#")) {
    url += "#/";
  }
  url = `${url}?currentView=LIST&currentCategory=${category.familyName}`;
  if (mountDetail) {
    const { rpm, noOfMount, kg, failSafe } = mountDetail;
    url += `&rpm=${rpm}&noOfMount=${noOfMount}&kg=${kg}&failSafe=${failSafe}`;
  }
  if (failSafe) {
    url += `&failSafe=${failSafe}`;
  }
  return url;
};
const MountCategories: React.FC<Props> = ({
  categoryDatas,
  updateData,
  mountDetail,
  failSafe,
}) => {
  const categoryList = categoryDatas?.map((categoryData) => {
    const imageUrl = `${getImageBaseUrl()}${categoryData.familyImgURL}`;
    return (
      <a
        href={getLink(categoryData, mountDetail, failSafe)}
        key={categoryData.familyName}
        className="cursor-pointer btn-item"
        title={categoryData.familyName}
        onClick={() => {
          (window as any).dataLayer.push({
            event: "engagement",
            eventCategory: "Mountfinder Category",
            eventAction: "Category ", // 'Weight of the Machine', 'Machine Speed', 'Number of Mounts' and 'Category'
            eventLabel: categoryData.familyName,
            resultsCount: categoryData.numOfFamilyMount,
          });
          updateData({
            currentCategory: categoryData.familyName,
            currentView: "LIST",
          });
        }}
      >
        <div className="MountFamilyImage flex flex-column">
          <img
            alt={categoryData.familyName}
            className="family-Mount-Image align-self-center"
            width={120}
            height={120}
            loading="lazy"
            src={imageUrl}
          ></img>
          <div className="div-1 p-2">
            <div className="family-name font-semibold ">
              <p>{categoryData.familyName}</p>
            </div>
            <div className="flex align-items-center justify-content-end">
              <div className="family-Mount-Number">
                {categoryData.numOfFamilyMount}
              </div>
            </div>
          </div>
        </div>
      </a>
    );
  });
  return (
    <section>
      <div className="custom-grid">{categoryList}</div>
    </section>
  );
};

export default MountCategories;
